import React, { Component } from 'react';
import moment from 'moment';

export default class JobFullDetailsInternalJobNotes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data || null,
      notes:[],
      isLoading: false,
      InternalNotesData : ''
    };
    this.handleNoteChange = this.handleNoteChange.bind(this);
    this.getInternalNote = this.getInternalNote.bind(this);
  }
  componentDidMount(){
    this.getAllNotes();
  }
  
  getAllNotes() {
    var that = this;
    let url = '/api/v1/portal/jobs/get-all-internal-jobnotes/'+this.state.data.id;
    return fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer '+window.api_token,
        "Accept": 'application/json'
      },
    }).
    then((responseText) => {
      let response = responseText.json();
      response.then((jsondata) => {
        that.setState({
          notes: jsondata.notes,
          isLoading: false,
        }, () => {
          that.getInternalNote()
        });
      });
    });
  }
  handleNoteChange(e,noteid){
    let msgBody = $('#note-row-'+noteid).val();
    this.setState({isLoading:true});
    let that = this;
      $.ajax({
        url: '/api/v1/portal/jobs/set-internal-job-note/'+noteid,
        method: 'POST',
        data: {api_token: window.api_token,message_body: msgBody},
        cache: false
      })
      .done(function(response) {
        that.setState({isLoading:false});
        $('#infomodallabel').html('Success');
        $('#infomodal .modal-body').html('Note updated successfully!!');
        $('#infomodal').modal();
      }).catch(function(err){
        $('#infomodallabel').html('Error');
        $('#infomodal .modal-body').html(err);
        $('#infomodal').modal();
      });
  }
  handleAddNewNote(e){
    let msgBody = $('#add-new-internal-note').val();
    let that = this;
    this.setState({isLoading:true});
    $.ajax({
      url: '/api/v1/portal/jobs/add-new-internal-job-note/'+this.state.data.id,
      method: 'POST',
      data: {api_token: window.api_token,message_body: msgBody},
      cache: false
    })
    .done(function(response) {
      that.setState({isLoading:false});
      $('#infomodallabel').html('Success');
      $('#infomodal .modal-body').html('New note added successfully!!');
      $('#infomodal').modal();
      that.setState({showAddBox : false})
      that.getAllNotes()
    }).catch(function(err){
      $('#infomodallabel').html('Error');
      $('#infomodal .modal-body').html(err);
      $('#infomodal').modal();
    })
  }

  getInternalNote(){
    let internalNotes = '';
    if(this.state.notes && this.state.notes.length > 0){
      this.state.notes.forEach(function(i,index) {
        var dateObj = '';
        var textNoteId = '';
        var noteRow = '';
        dateObj = moment(i.created_at).format("DD/MM/YYYY HH:mm:ss");
        let notejson = (i.modifications) ? JSON.parse(i.modifications) : "";
        notejson = notejson.note
        textNoteId = i.id;
        noteRow = "note-row-"+textNoteId;
          internalNotes = internalNotes+'<div class="row" key='+index+'>';
          internalNotes = internalNotes+'<div class="col-md-9">';
          internalNotes = internalNotes+'<textarea class="form-control form-control-lg" id="'+noteRow+'" defaultValue="'+notejson+'" readOnly>'+notejson+'';
          internalNotes = internalNotes+'</textarea>';
          internalNotes = internalNotes+'<br/>';
          internalNotes = internalNotes+'</div>';
          internalNotes = internalNotes+'<div class="col-md-3 padding-top-btm">';
          internalNotes = internalNotes+'<span><strong>'+i.full_name+' </strong>';
          internalNotes = internalNotes+'<i>'+dateObj+'';
          internalNotes = internalNotes+'</i></span></div></div>';
      });
      this.setState({InternalNotesData : internalNotes})
    }
  }
  render() {
    let handleNoteChange = this.handleNoteChange;
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
          <div className="subsection-container">
    
              <div className="row">
                <div className="col-md-12">
                  <button className="btn btn-primary btn-lg" onClick={()=>this.setState({showAddBox:true})}><i className="fa fa-plus"></i> Add New Note ?</button>
                </div>
              </div>
              <br/>
              {this.state.showAddBox ? 
              <div className="row">
                <div className="col-md-10">
                  <textarea className="form-control form-control-lg"
                   id={"add-new-internal-note"}>
                  </textarea>
                </div>
                <div className="col-md-2 padding-top-btm">
                  <a className="btn btn-primary btn-lg white-btn" 
                    onClick={(e)=>this.handleAddNewNote(e)}>Add Note
                    </a>
                </div>
              </div>
              : null }
              <br/>
              <div dangerouslySetInnerHTML={{__html: this.state.InternalNotesData}} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}